import React, { Component } from 'react'
import { computed } from 'mobx'
import { inject, observer } from 'mobx-react'

@inject('store')
@observer
export default class Rules extends Component {
  get store() {
    return this.props.store.appState
  }

  constructor(props) {
    super(props)
    this.state = { title: '' }
    this.store.useWidget('rules').then(this.setTitle)
  }

  @computed get html() {
    return this.store.widget.get('rules')
  }

  setTitle = ({ title }) => {
    this.setState({ title })
  }

  render() {
    const __html = this.html
    return (
      <div className='page posts'>
        <h2 className='page-title'>{this.state.title}</h2>
        {__html && <div dangerouslySetInnerHTML={{ __html }} />}
      </div>
    )
  }
}
